export enum LocalStorageType {
  MANDATORY,
  ANALYTICS,
  THIRDPARTY,
}
